import {Box, Text, Stack, Icon} from '@chakra-ui/react'
import {FiAlertTriangle} from '@react-icons/all-files/fi/FiAlertTriangle'

const PresentationNotice = () => {
  return (
    <Box
      position="sticky"
      top={0}
      zIndex="sticky"
      bg="red.500"
      color="white"
      px={4}
      py={3}
      textAlign="center">
      <Stack
        direction={{base: 'column', md: 'row'}}
        spacing={{base: 1, md: 3}}
        align="center"
        justify="center"
        maxW="5xl"
        mx="auto">
        <Stack direction="row" spacing={2} align="center">
          <Icon as={FiAlertTriangle} />
          <Text fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
            Achtung!
          </Text>
        </Stack>
        <Text>
          Bei dieser Seite handelt es sich um eine Präsentationsseite. Aktuellen
          Lagerstand gerne per Mail oder Telefon anfragen.
        </Text>
      </Stack>
    </Box>
  )
}

export default PresentationNotice
